// extracted by mini-css-extract-plugin
module.exports = {"container":"MFormContainer_container__1X5GZ","content":"MFormContainer_content__3-Gn2","spinnerContainer":"MFormContainer_spinnerContainer__1rLUm"};